<template>
  <div class="tab-content" v-if="data">
          <div class="dataNum">
            <dl>
              <dt>{{data.num}}</dt>
              <dd class="text">{{getText()}}人数</dd>
            </dl>
            <dl>
              <dt class="highlight">{{data.all_coin}}</dt>
              <dd class="text">{{getText()}}总收益</dd>
            </dl>
            <dl>
              <dt class="highlight">{{data.performance}}G</dt>
              <dd class="text">{{getText()}}总算力</dd>
            </dl>
            <dl v-if="type==='team'">
              <dt class="level"><img src="../../../assets/img/level.png"/></dt>
              <dd class="text">{{getText()}}总算力</dd>
            </dl>
          </div>
          <van-list

            v-model="loading"
            @load="onLoad"
            :offset="30"
            :finished="isFinished"
          >
          <!-- <div class="list"> -->
            <li class="list-item" v-for="(item,index) in teamList" :key="index">
              <dl>
                <dd class>
                  <span class="label">账号：</span>
                  <span>{{item.user_tel}}</span>
                </dd>
                <dd>
                  <span class="label">注册时间：</span>
                  <span>{{formateTime(item.reg_time)}}</span>
                </dd>
              </dl>
              <dl>
                <dd class>
                  <span class="label">编号：</span>
                  <span>{{item.promoter_no}}</span>
                </dd>
                <dd class>
                  <span class="label">{{type ==='direct' ? '是否有效会员：':'推荐人：'}}</span>
                  <span>{{getLevel(item)}}</span>
                </dd>
              </dl>
              <dl>
                <dd class>
                  <span class="label">算力：</span>
                  <span>{{item.power}}</span>
                </dd>
                <dd class>
                  <span class="label">{{type==='direct' ? '直推':'间推'}}人数：</span>
                  <span>{{type==='direct' ? item.direct_num : item.indirect_num}}</span>
                </dd>
              </dl>
            </li>
          </van-list>
          <!-- </div> -->
        </div>
</template>

<script>
export default {
     name: "tabContent",
     props: ["type"],
     data(){
       return {
         loading:false,
         data:null,
         isFinished:false,
         teamList:[],
         total:0,
         page:1
       }
     },
     created(){
        if(!this.data){
          this.getTeamData()
        }
        console.log(this.data)
        console.log(this.type)
     },
    methods:{
        getTeamData(pageNo=1){

          console.log(pageNo)
          this.ajax.post('appapi/user/teamlist',{
            type:this.type,
            page:pageNo
          })
          .then((res)=>{
            if(res.data.code === 1){
                let data = res.data.data
                let name = this.type === 'direct' ? 'direct': 'indirect'

                this.data = {
                    all_coin:data[`${name}_all_coin`],
                    num:data[`${name}_num`],
                    performance:data[`${name}_power`]
                }
                this.teamList =  pageNo > 1 ? this.teamList.concat(data.team_list.data ) : data.team_list.data ,
                this.total = data.team_list.total
                this.page = pageNo
                console.log( this.teamList)
                console.log( this.page)
               // this.page = data.team_list.current_page
                if(this.teamList.length >= this.total){
                  this.isFinished = true
                }
                this.loading=false
            }
          })
        },
        onLoad(){

          if(!this.isFinished){
            this.getTeamData(this.page+1)
          }else{
            this.loading = false
          }
        },
        getText(){
            return this.type ==='direct' ? '直推' :'间推'
        },
        formateTime(time){
          return time.split(' ')[0]
        },
        getLevel(item){
          if(this.type === 'direct'){
            return item.level ? item.level:'否'
          }else{
            return item.p_user_tel ? item.p_user_tel  :'否'
          }
        }

    }
}
</script>

<style lang="scss">

    .tab-content {
      padding: 27px 30px;
      .dataNum {
        @include flex($main: space-around);
        background-color: #fff;
        box-shadow: 0px 10px 29px 0px rgba(226, 226, 226, 0.4);
        border-radius: 20px;
        margin-bottom: 30px;
        dl {
          padding: 35px 0;
          color: #999999;
          font-size: 22px;
          font-weight: 500;
          text-align: center;
        }
        dt {
          font-size: 32px;
          font-weight: bold;
          color: rgba(102, 102, 102, 1);
          margin-bottom: 15px;
          &.highlight {
            color: #2ec779;
          }
          &.level{
            width:65px;
            height:52px;
            margin:0 auto;
          }
        }

      }
      .list {
        &-item {
          background: #fff;
          padding: 40px 52px;
          border-radius: 20px;
          margin-bottom: 30px;
          dl {
            @include flex();
            font-size: 24px;
            color: #999999;
            margin-bottom:18px;
            dd{
              flex:1;
            }
            .label {
              font-weight: bold;
              color: #3e3e3e;
            }
          }
        }
      }
    }
</style>
